import React from "react";
import EducationKasKirpikLifting from "../Components/education/EducationKasKirpikLifting";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function EducationKasKirpikLiftingPage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <EducationKasKirpikLifting />
    </>
  );
}

export default EducationKasKirpikLiftingPage;
